import LanguagePack from "../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import TextFitter from "../../../../../shared/lib/html5-software-library/src/ranj/layout/TextFitter";
import GameEvent from "../../../../../shared/src/ranj/app/core/GameEvent";
import GameModel from "../model/GameModel";
import AbstractWorkingMemoryScreenMediator from "./AbstractWorkingMemoryScreenMediator";

export default class EndScreenMediator extends AbstractWorkingMemoryScreenMediator {

    /**
     * 
     * @param {createjs.DisplayObject} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {GameModel} gameModel 
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameModel, saveModel, gameAssets) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, gameModel, saveModel, gameAssets);
    }

    initialize() {
        super.initialize();

        const titleTextFitter = new TextFitter(this._target.titleTextfield, { fontStep: 1 });
        if (this._gameModel.hasNextPuzzle() || !this._gameModel.wasLastPuzzleSuccessful()) {
            titleTextFitter.setText(this.getText("end.failureTitle"));
            this._target.bodyTextfield.text = this.getText("end.failureBody");
        } else {
            titleTextFitter.setText(this.getText("end.successTitle"));
            this._target.bodyTextfield.text = this.getText("end.successBody");
        }

        this._button = this.createButton(this._target.button, this._handleButtonClick.bind(this), this.getText("end.button"));

        this.anchorObject(this._target.titleTextfield, Anchor.T);
        this.anchorObject(this._target.bodyTextfield, Anchor.T);
        this.anchorObject(this._target.button, Anchor.B);

        this._exposeEndButton();
    }

    _handleButtonClick() {
        this._button.setEnabled(false);
        this.dispatch(GameEvent.EXIT);
    }

    // Used for integration testing by Equalture
    _exposeEndButton() {
        window.actions = window.actions || {};
        window.actions.clickEndButton = () => {
            return new Promise((resolve, reject) => {
                this._handleButtonClick();
                resolve();
            });
        }
    }
};
